import {
  FACEBOOK as FACEBOOK_CONSTANT,
  INSTAGRAM as INSTAGRAM_CONSTANT,
  LINKEDIN as LINKEDIN_CONSTANT,
  META,
  TIKTOK as TIKTOK_CONSTANT,
} from "../../../../utils/constants";
import {
  findFacebookAccountOption,
  findInstagramAccountOption,
  findLinkedInAccountOption,
  findTikTokAccountOption,
} from "./resolvePlatformAccountOptions";

const ACTIVE_MATCH_OPTIONS = { requireActiveMatch: true };

const SHARE_DEFAULT_RESOLVERS = [
  {
    platform: FACEBOOK_CONSTANT,
    defaultsKey: META,
    resolveAccount: (defaults, catalogs) =>
      findFacebookAccountOption(
        defaults,
        catalogs.uniqueFacebookPagesList,
        ACTIVE_MATCH_OPTIONS
      ),
  },
  {
    platform: INSTAGRAM_CONSTANT,
    defaultsKey: META,
    resolveAccount: (defaults, catalogs) =>
      findInstagramAccountOption(
        defaults,
        catalogs.uniqueInstagramBusinessList,
        ACTIVE_MATCH_OPTIONS
      ),
  },
  {
    platform: TIKTOK_CONSTANT,
    defaultsKey: TIKTOK_CONSTANT,
    resolveAccount: (defaults, catalogs) =>
      findTikTokAccountOption(
        defaults,
        catalogs.integrations,
        ACTIVE_MATCH_OPTIONS
      ),
  },
  {
    platform: LINKEDIN_CONSTANT,
    defaultsKey: LINKEDIN_CONSTANT,
    resolveAccount: (defaults, catalogs) =>
      findLinkedInAccountOption(
        defaults,
        catalogs.integrations,
        ACTIVE_MATCH_OPTIONS
      ),
  },
];

const RESOLVER_BY_PLATFORM = SHARE_DEFAULT_RESOLVERS.reduce(
  (acc, resolver) => {
    acc[resolver.platform] = resolver;
    return acc;
  },
  {}
);

export const SHARE_MODAL_ACCOUNT_PLATFORMS = SHARE_DEFAULT_RESOLVERS.map(
  (resolver) => resolver.platform
);

/**
 * Resolves a single ShareModal platform account from Settings platform defaults.
 */
export const getDefaultAccountForSharePlatform = ({
  platform,
  platformDefaults = {},
  uniqueFacebookPagesList = [],
  uniqueInstagramBusinessList = [],
  integrations = {},
}) => {
  const resolver = RESOLVER_BY_PLATFORM[platform];
  if (!resolver) return null;

  const defaults = platformDefaults[resolver.defaultsKey];
  if (!defaults) return null;

  return resolver.resolveAccount(defaults, {
    uniqueFacebookPagesList,
    uniqueInstagramBusinessList,
    integrations,
  });
};

/**
 * Fills empty ShareModal account fields from Settings defaults.
 * Skips platforms that already have an account selected.
 */
export const applyEmptyDefaultAccountsToShareModal = ({
  getValues,
  setValue,
  platforms = SHARE_MODAL_ACCOUNT_PLATFORMS,
  platformDefaults,
  uniqueFacebookPagesList,
  uniqueInstagramBusinessList,
  integrations,
}) => {
  const resolveArgs = {
    platformDefaults,
    uniqueFacebookPagesList,
    uniqueInstagramBusinessList,
    integrations,
  };

  platforms.forEach((platform) => {
    const currentAccount = getValues(`platformsData.${platform}.account`);
    if (currentAccount) return;

    const defaultAccount = getDefaultAccountForSharePlatform({
      platform,
      ...resolveArgs,
    });

    if (defaultAccount) {
      setValue(`platformsData.${platform}.account`, defaultAccount);
    }
  });
};
